import { motion } from "framer-motion";
import { Medal, Heart, Trophy, Users } from "lucide-react";

const features = [
  {
    icon: Medal,
    title: "Expert Coaches",
    description: "Learn from certified professionals with years of experience"
  },
  {
    icon: Heart,
    title: "Safe Environment",
    description: "State of the art facilities with proper safety equipment"
  },
  {
    icon: Trophy,
    title: "Proven Results",
    description: "Track record of developing successful gymnasts"
  },
  {
    icon: Users,
    title: "Small Groups",
    description: "Personalized attention in small class sizes"
  }
];

export const USP = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-white to-purple-50">
      <div className="container mx-auto px-4">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-3xl md:text-4xl font-bold text-center text-primary mb-16"
        >
        Here’s Why Parents Love Us
        </motion.h2>
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="bg-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-shadow"
            >
              <div className="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center mb-4">
                <feature.icon className="w-6 h-6 text-primary" />
              </div>
              <h3 className="text-xl font-semibold text-gray-800 mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};